export default {
  name: 'es',
  messages: {
    required: 'Es necesario que proporcione este campo',
    min: 'La cantidad de caracteres introducidos es inferior a el mínimo requerido para este campo.',
    max: 'Este campo excede la cantidad máxima de caracteres requeridos.',
    email: 'El formato de la dirección de correo electrónico es invalido.',
    number: 'Este formato solo debe contener caracteres númericos.',
    max_value: 'El valor proporcionado excede el máximo permitido para este campo',
    min_value: 'El valor proporcionado es inferior al permitido para este campo',
    alpha_spaces: 'Este campo solo debe contener caracteres alfabéticos y espacios.',
    unique: 'El valor introducido en este campo debe ser único y posiblemente ya este siendo utilizado.',
    confirmed: 'Los valores proporcionados no coinciden',
    exist: 'El valor indicado en este campo no es correcto.',
    decimal: 'Este campo solo debe contener números, los decimales se separan por punto y sin separador de miles.',
    date_format: 'El formato de la fecha indicada en este campo no es válido.',
    regex: 'Por favor revise el formato de este campo, parece no ser válido',
    rfc: 'El formato del RFC es incorrecto',
    url: 'El formato de la URL es incorrecto.',
    credit_card: 'El número de la tarjeta de crédito no es válido',
    match: 'El valor proporcionado no coincide o no es correcto.',
    json: 'El formato de de este valor no es válido, por favor revisar.'
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/locale/vee.validate.js